import type { HilbertCode } from "./types";

/**
 * Converts (x, y) coordinates into a Hilbert curve index.
 *
 * The Hilbert curve has better spatial locality than the Morton (Z-order) curve
 * because it never jumps between distant quadrants — neighboring points on the
 * curve are always spatially close.
 *
 * @param x - Column coordinate in range [0, 2^order - 1]
 * @param y - Row coordinate in range [0, 2^order - 1]
 * @param order - Hilbert curve order (grid is 2^order × 2^order)
 */
export const hilbertCode: HilbertCode = ({ x, y, order }) => {
  let rx: number;
  let ry: number;
  let distance = 0;
  let currentX = x;
  let currentY = y;

  for (let level = order - 1; level >= 0; level--) {
    const halfSize = 1 << level;

    rx = (currentX & halfSize) > 0 ? 1 : 0;
    ry = (currentY & halfSize) > 0 ? 1 : 0;

    distance += halfSize * halfSize * ((3 * rx) ^ ry);

    // Rotate the quadrant
    if (ry === 0) {
      if (rx === 1) {
        currentX = halfSize * 2 - 1 - currentX;
        currentY = halfSize * 2 - 1 - currentY;
      }

      const temp = currentX;
      currentX = currentY;
      currentY = temp;
    }
  }

  return distance;
};
